import React, { Component } from 'react';

export default class Image extends Component {
	constructor(props) {
		super(props);

		this.state = {
			"logo": props.assets.logo,
			"bgColor": props.assets.bgColor,
			"name": props.name
		};
	}

	render() {
		this.imgUrl = this.state.logo || "";

		if(this.imgUrl) {
			this.imgUrl = 'images/logos/' + this.imgUrl;

			let logo = {
				backgroundImage: 'url(' + this.imgUrl + ')',
				backgroundColor: this.state.bgColor
			};

			return [
				<span className="imageHolder" key="0" title={this.state.name} style={logo}></span>
			];
		} else {
			return [
				<span className="imageHolder noImage" key="0">
					{this.state.name}
				</span>
			];
		}
	}
}


// WEBPACK FOOTER //
// ./src/Image.js